export type MmaBreakBetweenRoundsValue = "00:30" | "00:45" | "01:00" | "01:30" | null;
export const DEFAULT_MMA_BREAK_BETWEEN_ROUNDS: Exclude<MmaBreakBetweenRoundsValue, null> = "01:00";

export const MMA_BREAK_BETWEEN_ROUNDS_OPTIONS: Array<{
    value: MmaBreakBetweenRoundsValue;
    labelTranslationKey: string;
}> = [
    {
        value: null,
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_no_limit",
    },
    {
        value: "00:30",
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_30_sec",
    },
    {
        value: "00:45",
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_45_sec",
    },
    {
        value: "01:00",
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_1_minute",
    },
    {
        value: "01:30",
        labelTranslationKey: "discipline_packages.mma_break_between_rounds_01_30",
    },
];

const PREDEFINED_BREAK_BETWEEN_ROUNDS_VALUES = new Set<string>(
    MMA_BREAK_BETWEEN_ROUNDS_OPTIONS.flatMap(option => (option.value === null ? [] : [option.value])),
);

export function shouldShowBreakBetweenRounds(numberOfRounds: number | null): boolean {
    return numberOfRounds !== null && numberOfRounds >= 2;
}

export function normalizeBreakBetweenRoundsSelection(value: string | null | undefined): MmaBreakBetweenRoundsValue {
    if (value === null || value === undefined) {
        return null;
    }

    return PREDEFINED_BREAK_BETWEEN_ROUNDS_VALUES.has(value) ? (value as Exclude<MmaBreakBetweenRoundsValue, null>) : null;
}

export function getBreakBetweenRoundsForRoundsChange(
    numberOfRounds: number | null,
    currentBreakBetweenRounds: string | null | undefined,
    previousNumberOfRounds: number | null = null,
): MmaBreakBetweenRoundsValue {
    if (!shouldShowBreakBetweenRounds(numberOfRounds)) {
        return null;
    }

    const normalizedBreakBetweenRounds = normalizeBreakBetweenRoundsSelection(currentBreakBetweenRounds);
    if (normalizedBreakBetweenRounds !== null) {
        return normalizedBreakBetweenRounds;
    }

    return shouldShowBreakBetweenRounds(previousNumberOfRounds) ? null : DEFAULT_MMA_BREAK_BETWEEN_ROUNDS;
}
